<template>
    <div class="view">
        <!--左侧-->
        <div class="left">
            <!-- 左侧上方卡片 -->
            <div class="l-top">
                <el-avatar :size="75" :src="avatarUrl"></el-avatar>
                <p>{{userInfo.name}}，欢迎登录</p>
                <p>{{memberText}}</p>
                <p>会员到期时间：{{userInfo.validDate.split(' ')[0] || '-'}}</p>
                <el-button
                    @click="showSelectRememberLevel = true"
                    type="primary"
                    size="mini"
                    :disabled="levelList.length === 0"
                >
                    等级变更
                </el-button>
            </div>

            <!-- 左侧下方导航 -->
            <div class="l-bottom">
                <ul>
                    <li class="active" @click="handleClickMenu(1)">
                        <span>
                          <i class="el-icon-user"></i>
                          基本信息
                        </span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li @click="handleClickMenu(2)">
                        <span>
                          <i class="el-icon-wallet"></i>
                          我的账号
                        </span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li @click="handleClickMenu(3)">
                        <span>
                          <i class="el-icon-bank-card"></i>
                          会员缴费
                        </span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li @click="handleClickMenu(4)">
                        <span>
                          <i class="el-icon-reading"></i>
                          我的证书
                        </span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li @click="handleClickMenu(5)">
                        <span>
                          <i class="el-icon-chat-dot-round"></i>
                          消息中心
                        </span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li @click="handleClickMenu(6)">
                        <span>
                          <i class="el-icon-time"></i>
                          缴费记录
                        </span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                </ul>
            </div>
        </div>

        <!--右侧-->
        <div class="right">
            <div class="r-top">

            </div>
            <div class="r-bottom">
                <router-view/>
            </div>
        </div>

        <!--等级选择dialog-->
        <el-dialog
            title="选择等级"
            :visible.sync="showSelectRememberLevel"
            :before-close="selectRememberLevelBeforeClose"
            width="320px"
        >
            <el-form label-position="right">
                <el-form-item label="选择等级">
                    <el-select v-model="selectLevel">
                        <el-option v-for="item in levelList" :key="item.id" :label="item.levelName" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSelectLevel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {getUserLevel, getUserCanSelectList, getUserLevelInfo, getAds} from '@/http/request'

    export default {
        name: "userCenter",
        data() {
            return {
                userLevelList: [],
                levelList: [],
                avatarUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
                showSelectRememberLevel: false, // 显示选择会员等级弹框
                selectLevel: null, // 已经选择的会员
                ads: [],
                formAds: { // 获取个人中心广告
                    limit: 10,
                    page: 1,
                    type: 1
                }
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo,
                studentID: state => state.studentID
            }),
            memberText() {
                const o = this.userLevelList.find(obj => obj.id === this.userInfo.userLevelId) || {};
                return o.levelName || '-';
            }
        },
        created() {
            this.getAds(); // 获取广告
            this.getUserLevel(); // 获取会员等级列表
            this.getUserCanSelectList(); // 获取可选会员等级
        },
        methods: {
            ...mapActions(['setCommodityInfo']),

            // 获取广告
            getAds() {
                getAds(this.formAds).then(({data}) => {
                    if (data.code === 0) {
                        this.ads = data.data.list;
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.msg
                        })
                    }
                })
            },

            // 获取会员等级列表
            getUserLevel() {
                getUserLevel().then(({data}) => {
                    if (data.code === 0) {
                        this.userLevelList = data.data
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.msg
                        })
                    }
                })
            },

            // 点击左侧菜单
            handleClickMenu(n) {
                switch (n) {
                    case 1:
                        this.$router.push('/userCenter/userInfo');
                        break;
                    case 2:
                        this.$router.push('/userCenter/myAccount');
                        break;
                    case 3:
                        // 点击会员缴费，查询当前会员的等级
                        this.getUserLevelInfo(this.userInfo.userLevelId);
                        break;
                    case 4:
                        this.$router.push('/userCenter/myCertificate');
                        break;
                    case 5:
                        this.$router.push('/userCenter/myMessageList');
                        break;
                    case 6:
                        this.$router.push('/userCenter/payRecord')
                        break;
                    default:
                }
            },

            // 获取可选择的会员等级
            getUserCanSelectList() {
                getUserCanSelectList().then(({data}) => {
                    if (data.code === 0) {
                        this.levelList = data.data;
                    }
                })
            },

            // 获取会员等级详情
            getUserLevelInfo(id) {
                const loading = this.$loading({
                    text: '请稍后',
                    lock: true,
                    fullscreen: true,
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                getUserLevelInfo(id).then(({data}) => {
                    loading.close()
                    if (data.code === 0) {
                        const o = data.data

                        // 商品信息存入vuex
                        this.setCommodityInfo(o);

                        if (o.price > 0) { // 价格大于0跳转支付页面
                            this.$router.push('/userCenter/pay');
                        } else { // 需要审核跳转提交资料页面
                            this.$message({
                                type: 'warning',
                                message: '当前用户不支持缴费'
                            })
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.msg
                        })
                    }
                }).catch(() => {
                    loading.close()
                })
            },

            // 等级选择dialog框关闭之前
            selectRememberLevelBeforeClose(done) {
                this.selectLevel = null;
                done()
            },

            // 等级选择dialog框关闭
            handleSelectLevel() {
                if (!this.selectLevel) {
                    this.$message({
                        type: 'warning',
                        message: '请选择等级'
                    })
                    return;
                }
                this.showSelectRememberLevel = false;
                this.setCommodityInfo(this.selectLevel);
                this.$router.push({
                    path: '/userCenter/pay'
                })
            }
        }
    };
</script>

<style lang="less" scoped>
    .view {
        min-height: 100vh;
        padding-bottom: 50px;
        display: flex;
        background: #f1f4f5;

        .left {
            width: 240px;
            padding: 15px;

            .l-top {
                width: 100%;
                height: 250px;
                padding: 20px;
                box-sizing: border-box;
                border-radius: 10px;
                background: #fff;
                margin-bottom: 15px;
                text-align: center;

                p:nth-child(2) {
                    margin: 10px;
                    font-size: 14px;
                    font-weight: 500;
                }

                p:nth-child(3) {
                    margin-bottom: 5px;
                    font-size: 12px;
                    color: #999;
                }

                p:nth-child(4) {
                    margin-bottom: 8px;
                    font-size: 12px;
                    color: #999;
                }
            }

            .l-bottom {
                width: 100%;
                height: 330px;
                border-radius: 10px;
                background: #fff;

                ul {
                    padding: 15px 0;

                    li {
                        padding: 15px 30px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 14px;
                        color: #666;
                        cursor: pointer;

                        &.active {
                            color: #1399DC;
                        }
                    }
                }
            }
        }

        .right {
            flex: 1;
            margin: 15px 15px 0 0;
            padding: 15px;
            border-radius: 10px;
            background: #fff;
            overflow: hidden;
            .r-top {
                height: 200px;
                margin-bottom: 15px;
            }

            .r-bottom {
                min-height: 500px;
                border-radius: 10px;
            }
        }
    }
</style>